import React from 'react';
import Button from '@material-ui/core/Button';
import { Box } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ChoiceImage } from 'src/images/components/form';
import { ImageList } from './ImageList';
import Modal from './Modal';

const useStyles = makeStyles((theme) => ({
  button: {
    margin: theme.spacing(1),
  },
}));

export const AddListImages = ({
  input: {
    value,
    onChange,
  },
  type,
  onAccept,
  many,
  initialData,
  subComponent,
  title,
  subtitle,
  children,
}) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [selected, setSelected] = React.useState([]);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleConfirm = () => {
    if (onAccept) {
      onAccept(selected);
    } else onChange(selected);
    setSelected([]);
    setOpen(false);
  };

  return (
    <>
      {children && React.cloneElement(children, { handleOpen, src: value })}
      {!children && <ChoiceImage nocrop type={type} handleOpen={handleOpen} src={value} />}
      <Modal
        handleClose={handleClose}
        open={open}
        title={title}
        subtitle={subtitle}
      >
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexDirection="column"
          flex=".1"
        >
          {subComponent && subComponent()}
        </Box>
        <Box
          display="flex"
          flexDirection="column"
          width="100%"
          overflow="scroll"
          justifyContent="center"
          alignItems="center"
          flex=".8"
        >
          <ImageList
            many={many}
            initialData={initialData}
            selected={selected}
            type={type}
            setSelected={setSelected}
          />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          flexDirection="row"
          flex=".1"
        >
          <Button
            variant="contained"
            color="secondary"
            type="submit"
            data-cy="btn-validate-image"
            className={classes.button}
            onClick={handleConfirm}
          >
            Valider
          </Button>
          <Button
            variant="contained"
            type="submit"
            color="primary"
            className={classes.button}
            onClick={handleClose}
          >
            Fermer
          </Button>
        </Box>
      </Modal>
    </>
  );
};
